<!--
	Last modified: 2022/07/05 13:37:53
-->
<template>
	<div v-once class="c-post-scribe-script"></div>
</template>

<script>
export default {
	name: 'PostScribeScript',

	beforeRouteLeave(to) {
		window.location.assign(to.path);
	},

	props: {
		html: {
			type: String,
			required: true,
		},
		lazyload: {
			type: Boolean,
			default: false,
		},
	},

	data() {
		return {
			observer: null,
		};
	},

	mounted() {
		if (this.lazyload) {
			this.observer = new IntersectionObserver(
				(entries) => {
					if (entries[0].isIntersecting) {
						this.inject();
						this.observer?.disconnect?.();
					}
				},
				{
					rootMargin: `${Math.min(200, window.innerHeight / 10)}px`,
				}
			);
			this.observer.observe(this.$el);
		} else {
			this.inject();
		}
	},

	beforeDestroy() {
		this.observer?.disconnect?.();
	},

	methods: {
		inject() {
			const postscribe = require('postscribe');
			postscribe(this.$el, this.html, {
				// We emit some of the availabe callbacks (https://www.npmjs.com/package/postscribe#usage)
				done: () => {
					this.$emit('done');
				},
				error: (error) => {
					this.$emit('error', error);
				},
			});
		},
	},
};
</script>
